
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen,langno, langtw, langjp, langxby,langit,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  currency: {
    bb: '交換',
    bba: '交換口座',
    hy: '契約',
    jg: 'スワップ',
    hya: '契約アカウント'
  },
  index: {
    h24: '24時間の額',
    header_title: ['デジタル資産取引を選択する ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'ワンストップのブロックチェーンデジタル資産取引を完了する',
    header_msg: '安全-安定-信頼できる',
    register_title: '登録する ' + window.GLOBAL.LANG_TITLE.zh + ' グローバルアカウントは取引の旅を開始します',
    register_pl: 'eメールまたは携帯電話番号を入力してください',
    register: '登録',
    featureTitleWhy: 'なぜ私たちを選ぶのか',
    featureTitle: '安全，安定，信頼性',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: '安全なウォレットテクノロジー', msg: ['コールドウォレットとホットウォレットのテクノロジーは世界トップのセキュリティチームによって開発されており、コインの紛失は一度もありません。',''] },
      { icon: icon2, title: '豊富な暗号資産事業', msg: ['サポートスポットや複数のデリバティブ取引などは、暗号化された資産の世界へのあなたの個人的なスチュワードです。',''] },
      { icon: icon3, title: '世界中に分散している顧客', msg: ['世界130を超える国または地域のユーザーに、暗号化された資産サービスの全範囲を提供します。', ''] }
    ],
    bannerList: [
      {icon:banner01,title: "業界をリードするセキュリティと安定性の提供に取り組んでいます",msg:["投資家の資産の安全を保護するスマートコントラクト", "実際の取引実績", "24時間サービス保証"]},
      {icon:banner02,title: "簡単な操作ですぐに売買したい",msg:["簡単な取引画面", "アカウントの残高にすぐに反映されます", "ほとんどの暗号通貨は取引できます"]},
      {icon:banner03,title:"決済契約取引で積極的に利益を上げたい",msg:["同時に口座を開設","多数の取引先物への戦略的投資","24取引可能1日何時間,1年365日,週末でも"]}
    ],
    featureList2: [
      {icon: icon1_01,title: "透明性と開放性",msg:["ブロックチェーンとスマートコントラクトの特性を使用し,チェーンでのトランザクションパフォーマンスを実現し,スマートコントラクトを使用して投資家の資産の安全を確保する", ""] },
      {icon: icon1_02,title: "Smart Investment",msg:["トップのクオンツアナリストが提供する多様な戦略により,自由に選択できます", ""]},
      {icon: icon1_03,title: "リスクグレーディング",msg:["各投資家のさまざまなリスクと資産管理の好みに基づいて分散投資商品を設計し,投資のしきい値を効果的に排除する", ""]},
      {icon: icon1_04,title: "多様な製品",msg:["さまざまなタイプのユーザー投資ニーズと柔軟なプラットフォームメカニズムを提供し,市場よりも優れた革新的な金融サービスを生み出し続けます", ""]}
    ],
    featureTitle2: 'いつでもどこでもマルチプラットフォーム端末トランザクション',
    featureMsg2: 'iOSとAndroidの複数のプラットフォームをカバーし、フルサービス機能をサポートします',
    tab: ['主流の通貨', '24H 増加リスト'],
    thead: ['名前', '最新価格', 'その日の最高価格', 'その日の最低価格', '増加リスト', '24時間ボリューム', 'オペレーティング'],
    more: 'もっと >',
    btn: '取引',
    dealsTitle: 'ワンストップトレーディングサービス',
    dealsTab:[
      { title: '交換', content: '交換は、他の通貨を購入するための評価の単位としてUSDTを使用して、デジタル資産間の交換のためのものです。'+window.GLOBAL.LANG_TITLE.zh+'取引所は、ビットコイン、イーサリアム、ライトコインなどのデジタル資産のリアルタイムフェッチをサポートしています。', src:'/static/image/deals-1.jpg', path: '' },
      { title: '契約', content: 'デジタル通貨の金融デリバティブは、収入を得るためにロングまたはショートの販売契約を購入する選択をサポートするだけでなく、操作が簡単で、期限が切れることはありません。'+window.GLOBAL.LANG_TITLE.zh+'この契約には、最大100倍のレバレッジを備えた高度なリスク管理システムがあります。', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['お気に入り', '契約', '交換'],
    thead: ['通貨', '最新価格', '24時間変更', '24H 最低価格', '24H最高価格','24Hボリューム', '操作'],
    nodata: 'データなし'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "当社について",
        dd: [{ title: "会社概要", id: 1 }, { title: "ヘルプセンター", type: 'help' }]
      },
      {
        dt: "ユーザーサポート",
        dd: [
          { title: "ユーザー規約", id: 3 },
          { title: "個人情報保護方針", id: 5 }
        ]
      },
      {
        dt: "お問い合わせ",
        icon: true
      }
    ]
  },
  nav: {
    btn: ["ログインする", "登録", "資産運用管理","ダウンロードApp"],
    nav: [
      { title: "ホーム", path: "/index",name: 'index' },
      { title: "市場", path: "/market",name: 'market' },
      // { title: "交換", path: "/deal", name: 'deal'},
      // { title: "契約", path: "/deal_c", name: 'deal_c' },
      { title: "スワップ契約", path: "/deal_jg", name: 'deal_jg' },
      { title: "リベートの保持", path: "/profit_index",name: 'profit_index' }
    ],
    nav2: [{ title: "私の資産", path: "/asset" }],
    menus: [
      { icon: langzh, title: "ユーザーセンター", path: "/setting" },
      { icon: langen, title: "ログアウト" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      {
        icon: langno,
        lang: "Norsk",
        key: 'no'
      },
      {"icon": langit,"lang": "Italiano","key": "it"},
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "下载"
  },
  // ログインする
  login: {
    login: '欢迎ログインする',
    msg: 'ログインしたアカウントを入力してください',
    list: ['携帯電話/Eメール', 'パスワード', 'パスワードを忘れましたか？', 'ログインする', 'アカウントがありません、今すぐログインしてください'],
    message: 'アカウントまたはパスワードを空にすることはできません'
  },
  register: {
    dl: ['お使いの携帯電話を登録します', 'メール登録'],
    title: 'アカウントを登録',
    country: '国籍',
    country_info: '登録後に国籍情報を変更することはできませんので、必ず誠実に選択してください',
    account: '口座番号',
    code_text: '検証コード',
    code_btn: '検証コードを取得',
    code_unit: 's',
    code_no_data: '確認コードを入力する必要があります',
    password_text: 'パスワードをもう一度入力してください',
    password_again_text: 'もう一度パスワードを入力してください',
    pid_text: '招待コード',
    pid_pl: 'オプション',
    invitation_code_no_data: '招待コードが必要です',
    xy: 'ユーザー規約',
    xy_no_checked: '同意を選択してください',
    agree:'私は読んで同意しました',
    register_btn: '登録',
    bz: ['登録後に国籍情報を変更することはできませんので、誠実に選択してください。 ','確認メールがスパムと誤認される可能性がありますので、よくご確認ください。', '保管してください' + window.GLOBAL.LANG_TITLE.zh + 'アカウント番号とログインパスワード。', '他のウェブサイトと同じログインパスワードを使用しないでください。'],
    account_no_data: 'アカウント番号は空欄にできません',
    code_no_equality: '確認コードが等しくない',
    password_no_data: 'パスワードを空白にすることはできません',
    password_no_equality: '2つのパスワードが等しくない'
  },
  // 設定パスワード
  bindmpwd: {
    title: '設定パスワード',
    account: '口座',
    code_text: '検証コード',
    code_btn: '検証コードを取得',
    code_unit: 's',
    password_text: 'パスワードをもう一度入力してください',
    password_again_text: 'パスワードをもう一度入力してください',
    code_no_data: '確認コードを入力する必要があります',
    code_no_equality: '確認コードが等しくない',
    password_no_data: 'パスワード不能为空',
    password_no_equality: '2つのパスワードが等しくない',
    bindmpwd_btn: '確認',
    phone_no_data: '電話番号を空白にすることはできません',
    password_login_text: '请输入ログインするパスワード',
    password_trade_text: 'パスワードの長さ6桁',
    password_again_tarde_text: 'パスワードの長さ6桁',
  },
  // 忘记パスワード
  forgetpwd: {
    title: ['パスワードを変更する', 'パスワードをお忘れですか'],
    account: '口座',
    code_text: '検証コード',
    code_btn: '検証コードを取得',
    code_unit: 's',
    password_text: 'パスワードをもう一度入力してください',
    password_again_text: 'パスワードをもう一度入力してください',

    phone_no_data: '電話番号を空白にすることはできません',

    account_no_data: 'アカウント番号は空欄にできません',
    code_no_data: '確認コードを入力する必要があります',
    code_no_equality: '確認コードが等しくない',
    password_no_data: 'パスワード不能为空',
    password_no_equality: '2つのパスワードが等しくない',
    forgetpwd_btn: '確認'
  },
  // 绑定手机号码
  bindphone: {
    title: '携帯電話番号をバインドする',
    phone_text: '電話番号',
  },
  person: {
    more: 'さらに読み込む',
    no_more: 'これ以上のデータはありません',
    index_center:"ユーザーセンター",
    index_menus: [
      { icon: zhsz, title: "アカウント管理", path: '/setting' },
      { icon: sfrz, title: "KYC認証", path: '/sfyz' },
      { icon: sfrz, title: "一次認証", path: '/smauth' },
      { icon: sfrz, title: "二次認証", path: '/seniorauth' },
      { icon: jtrz, title: "アドレス認証", path: '/dzrz' },
      { icon: jtrz, title: "暗号通貨", path: '/kjmbSelect' },
      { icon: jtrz, title: "クレジットスコア", path: '/credit' },
      { icon: jtrz, title: "記録", path: '/deallog' },
      { icon: jtrz, title: "預金記録", path: '/cbjl' },
      { icon: jtrz, title: "撤退記録", path: '/tbjl' },
    ],
    cbtb: '預入`出金',
    jymx: '取引の詳細',
    xyf: {
      'title': 'クレジットスコア',
      'pgsj': '評価時間'
    },
    smrz:{
       title:'本人確認' ,
       sure_title:'合格しました本人確認',
       zj_type:'有効なIDの種類' ,
       zj_info:['1.認証情報が確認されると、変更できません。「、」を正直に入力してください。2。認証された実名情報を再認証することはできません。'],
       zj_name:'本名' ,
       zj_num:'ID番号' ,
       zj_btn:'確認' ,
       zj_rebtn:'再確認' ,
       zj_sebtn:'二次認証' ,
       zj_type_array:[{name:'IDカード',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "IDカード"
        },
        {
            id: 2,
            name: "パスポート"
        },
        {
            id: 3,
            name: "運転免許証"
        },
        {
            id: 4,
            name: "居住許可証"
        },
        {
            id: 5,
            name: "その他"
        }
       ],
       zj_data:{city:'国籍を空にすることはできません',type:'クレデンシャルタイプを空にすることはできません',name:'氏名は空欄にできません',zj_num:'ID番号は空欄にできません'},
       zsxm: '本名',
       qsrzsxm: '本名を入力してください',
       zjlx: '有効なIDの種類',
       qxzzjlx: 'IDの種類を選択してください',
       sfz: 'IDカード',
       zjhm: 'ID番号',
       qsrzjhm: 'ID番号を入力してください',
       sczjz: 'ドキュメントをアップロードする',
       zjzm: 'IDカードの表面の写真をアップロードする',
       zjfm: 'IDカードの裏面の写真をアップロードする',
       qsczjzm: 'IDカードの表面の写真をアップロードする',
       qsczjfm: 'IDカードの裏面の写真をアップロードする',
       scqmz: 'IDカードと個人署名をアップロードする',
       qscscqmz: 'IDカードと個人署名をアップロードする',
       zj: [
         {
           id: 1,
           title: 'IDカード'
         },
         {
           id: 2,
           title: 'パスポート'
         },
         {
           id: 3,
           title: 'その他'
         },
       ],
       tj: '提出',
       shz: '審査中',
       shtg: '承認'
    },
    gjrz:{
      title:'二次認証',
      zj_info:['1. 画像は、8MBより小さく、JPG、JPEG、またはPNG形式がサポートされます。','2. IDカードは、写真が明瞭で、修正や妨害があってはなりません。 IDカードの番号および所有者の氏名がはっきり映っていなければなりません。','3. 帽子をかぶっている写真は不可で、メークアップをしていないものが推奨されます。顔の特徴がはっきりと認識できるもので、両腕が全部露出しているものでなければなりません。'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'セキュリティ設定',
      bind:[{bind_title:'パスワードを再設定する',bind_name:'Eメール'},{bind_title:'設定取引パスワード',bind_name:'Eメール'}]
    },
    wdtg:{
      own_code:'招待コード',
      own_code_url:'招待リンク',
      own_push_title:'私の昇格',
      own_push_content:['招待収入の合計','招待数','人'],
      own_push_content_profit:['一级邀请收益','二级邀请收益','三级邀请收益','四级邀请收益'],
      own_push_content_num:['一级邀请人数','二级邀请人数','三级邀请人数','四级邀请人数'],
      own_push_profit_title: ['ID', '所得', '備考','時間を追加する'],
      own_push_num_title: ['ID', '名称', '电话','時間を追加する'],
    },
    jyzt_td: ['時間', '詳細', '量'],
    cbjl_td: ['時間', '通貨', '額','状態'],
    sfrz_txt: ['本人確認', 'レビューを送信しました。結果が出るまでお待ちください', '二次認証に合格しました', 'IDカードの前面', 'IDカードの裏面', '認証','認証に失敗しました。再認証してください'],

    zhsz_txt: ['アカウントのセキュリティレベル: #', 'アカウントのセキュリティレベル: #，口と座席の安全を確保するために、より多くの情報を改善する'],
    zhsz_m: '強い',
    zhsz_n: '弱い',
    zhsz_p: '危険な',
    zhsz_detailList: [
      // { icon: iconchecked, title: 'アカウント招待コード', value: '', btn: '复制招待コード', class: 'copy', event: 'copy' },
      // { icon: '/static/image/User_Center-email.png', title: 'Eメール', value: '用于ログインする、出金、安全設定时使用', value2:'',btn: '绑定', btn2: '已绑定', path2: '/bindphone' },

      // { icon: '/static/image/User_Center-phone.png', title: '手机', value: '用于提现，修改パスワード，安全設定时用以收取验证短信', value2:'', btn: '绑定', btn2: '已绑定', path2: '/bindphone' },
      { icon: '/static/image/User_Center-password.png', title: 'ログインするパスワード', value: 'インターネットアカウントは盗まれる危険性があります。アカウントのセキュリティを保護するために、定期的にパスワードを変更することをお勧めします。',value2:'', btn: '変更する',bind_email:'最初にEメールまたは携帯電話をバインドしてください', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: '取引パスワード', value: '設定パスワード', btn: '設定', path: '/bindmpwd' }
    ],
    sksz_txt: ['コレクションの設定', 'セーブ'],
    sksz_list: [
      { label: "ユーザー名:", pl: "ユーザー名を入力してください", key: "name" },
      { label: "銀行口座の氏名:", pl: "銀行口座の氏名を入力してください", key: "bank_name" },
      { label: "銀行口座:", pl: "口座番号を入力してください", key: "bank_number" },
      { label: "Alipayアカウント:", pl: "Alipayアカウントを入力してください", key: "alipay_account" },
      { label: "WeChatのニックネーム：", pl: "WeChatのニックネームを入力してください", key: "weixin_nickname" },
      { label: "WeChatアカウント：", pl: "WeChatアカウントを入力してください", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'ホーム',
    prev: '前のページ',
    next: '次のページ',
    last: '最後のページ',
    no_data: 'データなし',
  },
  asset: {
    title: '私の資産',
    zjhz: '资金划転',
    cb: '預入',
    gz: 'USDT估值',
    atnv: [],
    zh_title: '変換された総資産：',
    index_title: '資産',
    address_title: '通貨',
    address_txt: ['選んでください', '出金先', 'コンテンツを入力してください', '備考', 'アドレスリスト'],
    address_btn: ['追加', 'セーブ', '削除', '編集'],
    address_td: ['通貨', '出金先', '備考', '操作'],
    currency_td: ['通貨', '利用可能', 'フリーズ', '換算済額'],

    table_title: '総資産：',
    table_address_title: '出金先管理',
    table_td: ['通貨', '利用可能', 'フリーズ', '換算済額', '操作'],
    table_btn: ['預入', '出金', '記録', '取引'],

    money_text: ['出金先', '選んでください', '額', '利用可能：', '手数料',
      '入金量', '取引パスワード','タグ(Memo)','最低'],
    money_btn: '出金',
    xzbz: '通貨選択',
    money_msg: ['リマインダ：', '', '','','',''],

    recharge_title: '預入住所',
    recharge_btn: ['コピー', 'QRコード', '預入'],
    recharge_text: ['額', 'リマインダ：', 'この通貨以外の資産を上記住所に追加しないでください。資産の出金ができなくなります。', 'USDT預入仅支持simple send的方法，使用その他方法（send all）的預入暂时无法上账，请您谅解。', '凭证', 'バウチャーの説明(オプション)','チェーン名'],

    record_title: '财务記録',
    record_td: ['額', '記録', '時間'],

    transfer_title: '転送',
    transfer_btn: ['すべて', '転送'],
    transfer_text: ['从', '至', '请输入転送額', '利用可能：'],
    "bq": "ラベル(Memo)",
    "qsrbq":"ラベルを入力してください",
    "yhktx":"銀行カードの引き出し",
    "yhmc": "銀行名",
    "qsryhmc": "銀行名を入力してください",
    "yhzh": "銀行口座",
    "qsryhzh":"銀行口座番号を入力してください",
    "gjhkdm": "国際送金コード",
    "qsrgjhkdm":"国際送金コードを入力してください",
    "yhdz": "銀行の住所",
    "qsryhdz":"銀行の住所を入力してください",
    "skrxm": "支払者名",
    "qsrskrxm":"お支払い受取人の名前を入力してください",
    "skrdh": "受取人の電話",
    "qsrskrdh":"お支払い受取人の電話番号を入力してください",
    "skrdz": "受取人の住所",
    "qsrskrdz":"受取人の住所を入力してください"
  },
  text: {
    btn: '戻る',
    login: 'サインインしてください'
  },
  deal: {
    chooseType: '手数料の種類',
    choose: '選んでください',
    balance: '残高：',
    account: ['口座', '利用可能', '/フリーズ', '転送'],
    dir: ['購入', '販売'],
    dir2: ['利用可能', '販売可能'],
    cs: 'お気に入り',
    sxf: '費用',
    jye: '取引金額',
    sc_list: ['市場', '名前', '増加する'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['通貨', '最新価格', '増加する'],
    k_line_txt: ['≈', '', '増加する', '最高価格', '最低価格', '24Hの額'],
    tabListLTitle: ["現在の手数料", "履歴（完了済）"],
    tabListLEntrust: ["購入", "売却"],
    tabListRTitle: ["リミット取引", "市場価格取引"],
    table_btn: ['キャンセル'],
    index_td_l: ['時間', '取引パートナー', '額', '価格', '操作'],
    index_td_r: ['最新価格', '方向', '価格', '額'],
    index_td_r2: ['最新取引', '時間', '価格', '取引量'],
    table_txt: ['処理済額', 'キャンセル済み'],

    db_1_txt: ['利用可能', '購入价', '売却价', '購入量', '売却量', '取引金額', '市場で最高の価格で購入する', '市場で最高の価格で販売する', '購入手', '売却手'],
    db_2_txt: ['価格', 'レバー', '選んでください', '手数料', '1ロット相当', '手', '契約市值', '保証金', '市場で最高の価格で購入する', '市場で最高の価格で販売する'],
    pathList: ['契約記録', '取引記録'],
    db_btn: ['購入(ロング)', '売却(ショート)'],
    tabListLTitle2: ['現在の手数料'],

    lt_btn: ['ワンクリック清算', 'テイクプロフィット・ストップロス', '清算', '提出', '戻る'],
    lt_txt: ['リスク率：', '総収益：'],
    lt_td: ['種類','レバレッジ', 'ポジション価格', '現在価格', '保証金', 'テイクプロフィット価格', 'ストップロス価格', '開始時間', '手数料', '総収益', '操作'],
    lt_dl: ['テイクプロフィット・ストップロス', 'テイクプロフィット価格', 'ストップロス価格'],

    lt_0_btn: ['キャンセル'],
    lt_0_td: ['联系方式', '通貨', '額', '現在価格', '手数料', '操作'],

    lt_1_btn: ['清算'],
    lt_1_txt: ['終了中'],
    lt_1_td: ['種類', 'ポジション価格', '現在価格', '保証金', 'テイクプロフィット価格', 'ストップロス価格', '開始時間', '手数料', '総収益', '操作'],
    node_data: 'データなし',

    lt_3_txt: ['已平仓', '爆仓'],
    lt_3_td: ['種類', '手数料', 'ポジション価格', '終値', 'テイクプロフィット価格', 'ストップロス価格', '保証金', '利用可能保証金', '開始時間', '清算時間', '手数料',
      '総収益', '操作'],

    lt_4_txt: ['キャンセル済み'],
    cm: ['公開時間', '発行番号', '総循環', '合計金額', '公式ウェブサイト','ホワイトペーパー','情報'],
    qsrsl: '金額を入力してください',
    qsrss: 'ロットを入力してください',
  },
  notice:{
      notice_title:'アナウンスセンター',
  },
  bzhl:{
    title: 'リベートの保持',
    ttzbt: '毎日お金を稼ぎ続ける',
    wdtg: 'エスクロー注文',
    zztgdzj: '管理中の資金',
    yjjrsy: '毎日推定',
    ljsy: '累計収益',
    tgzdd: '管理中の注文',
    tgdd: '管理中の注文',
    t1: '低リスクで安定した財務管理、必要に応じていつでも償還可能',
    t2: 'あなたの無料のお金の管理アシスタント',
    cljxcp: '商品サイクル',
    dbxe: 'シングルリミット',
    rsyl: '収率(%)',
    rsyl2: '日次収益率：',
    zq: 'サイクル',
    qmr: '購入',
    ckgd: 'もっと',
    cpgk: '商品概要',
    pxsj: '配当時間',
    tgzj: '管理資金',
    tqsh: '早期償還',
    cpld: '商品のハイライト',
    cpgz: 'ルール',
    cont: 'USDTの収益は、プラットフォームでUSDTをホストすることにより、プラットフォームの専門家チームによって管理されます。参加者は、ファンドのホスティング期間中にプラットフォームの収益分配を取得できます。これはいつでもアクセスでき、安全で便利です。',
    zj: '100%資金',
    aqbz: 'セキュリティ',
    jjrsy: '休日の収入',
    bjd: '途切れない',
    cgcrh: '入金が成功した後',
    dtqx: '当日の利息を計算する',
    ljzr: '今すぐ転送',
    xqglgj: '無料のお金の管理ツール',
    ddh: '注文番号',
    tgje: '管理額',
    tgsj: 'サイクル',
    yhl: '管理額/管理時間',
    xdsj: '注文時間',
    zt: '状態',
    fh: '戻る',
    qrnhsy: '7日間の年収',
    ygy: '1ヶ月',
    bn: '半年',
    yn: '1年',
    yuan: '$',
    tzfx: '投資リスク',
    shsc: '償還時間',
    di: '低',
    yggzr: 'ある営業日',
    msgsxf: '無料サブスクリプションロット',
    mr: '毎日',
    dqfh: '満期時配当',
    ljgm: '今すぐ購入する',
    tgz: '管理中の注文',
    sh: '償還済',
    ywc: '完了',
    ysh: '償還済',
    all: '全て',
    "xzbzts": "シンプルで安全。 配当は複数の通貨で選択できます",
    "qtbz": "その他のコイン"
  },
  pay:{
    qsrjymm: '6桁のパスワード',
    tbmmts: 'ユーザーセンターにアクセスして、トランザクションパスワードを設定してください',
  },
  tips:{
    qxztbdz: '出金住所を入力してください',
    qsrtbsl: '出金通貨の額を入力してください'
  },
  statusText: ['失敗','処理','成功'],
  dzrz: {
    title: 'アドレス認証',
    sdddz: '公共料金の請求先住所',
    zdtpsc: '請求書画像のアップロード',
    qsrsdddz: '住所情報を入力し、公共料金またはブロードバンドアドレスの請求書を提出する必要があります',
    qsczdtp: '請求書の写真をアップロードしてください',
    status: ['審査中','承認'],
    qd: '確認',
  },
  jgcc: {
    wtgd: '現在の手数料',
    cj: '取引成功',
    jj: '情報',
    zc: '現在',
    lszc: '履歴',
    qblx: '全種類',
    xj: '現在の価格',
    sj: '時間',
    fx: '方向',
    jg: '価格',
    sl: '額',
    jgsj: 'スワップ時間',
    gmj: '購入価格',
    jsj: '決済価格',
    yk: '総収益',
    xq: '詳細',
    mz: 'ロング購入',
    md: 'ショート売却',
    dqye: '現在の残高',
    gb: 'クローズ',
    jxxd: '注文を続ける',
    qrxd: '確認',
    ddqr: '注文確認',
    sxf: '費用',
    kyye: '残高',
    jypz: '名前',
    jyfx: '取引の方向',
    tzje: '投資価格',
    tzjeTips: '最低価格 0',
    dqsj: '満期時間',
    jssj: '配当時間',
    gmsj: '購入時間',
    sy: '収益',
    zxje: '最小額 ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: "最大額 ",
    qsrje: '金額を入力してください',
    zxtzje: '最小数量 ',
    yebz: '残高不足です',
    xq: '詳細',
    ddz: '待っています',
    jgjl: 'スワップ記録',
    bz: '通貨',
    cz: '操作'
  },
  kjmb: {
    title: '暗号通貨',
    fzcg: '正常にコピー',
    ljmb: '暗号通貨',
    lxkf: 'カスタマーサービスに連絡する'
  },
  news: {
    title: '私のメッセージ',
    "gg":"発表",
    ckxq: '詳細を見る'
  },
  statusTabs:['保留中の注文', '取引中','終了', 'キャンセル済み'],
  "chongzhi":{
    "zy": "重要",
    "cbxx": "トークンデポジット情報",
    "qsrsl": "デポジット額を入力してください",
    "tips2": "1.ウォレット/プラットフォームの互換性：つまり、ネットワークがサポートされています。ターゲットプラットフォームが引き出しネットワークをサポートしていない場合、アセットを取得できません。",
    "tips3": "2.トップアップネットワークとターゲットプラットフォームは同じです。ターゲットアドレスを選択した場合はイーサリアムネットワークですが、トップアップがTRC20スマートチェーンを選択した場合、デジタル資産を取得できない可能性があります。",
    "tips4": "3.再充電する前に、住所と金額が正しいことを確認してください。",
    "tips5": "注意：ブロックネットワークの匿名性とプライバシーのため、間違った情報を入力すると、対応するアセットが失われます。充電先住所と数量をよく確認してください",
    "tips2_1": "•上記の住所に非現地通貨の資産を請求しないでください。請求しないと、資産を取得できません。",
    "tips2_2": "•デジタル通貨は時間内に配信できません。実際の到着時間は、ブロックチェーンの確認速度によって異なります。",
    "tips2_3": "•リチャージアドレスは頻繁に変更されることはなく、リチャージできます。変更があった場合は、ウェブサイトのお知らせまたはメールで通知できるよう最善を尽くします。"
  },
  "tibi":{
    "tbxx": "引き出し情報",
    "qsrbq": "ラベルを入力してください",
    "tbTips1": "•資金の安全を確保するため、アカウントのセキュリティポリシーが変更されたり、パスワードが変更されたりした場合は、手動で引き出しを確認します。スタッフから電話またはメールで連絡が来るまで、しばらくお待ちください。",
    "tbTips2": "•情報が改ざんされたり漏洩したりしないように、コンピューターとブラウザーが安全であることを確認してください。",
    "tbTips3": "•あなたが言及したデジタル資産はワンコインマルチチェーン資産です。どのチェーンから調達することを選択しても、所有する引き出しページに表示されるデジタル資産の合計量が減少することを意味します対応する調達額によって。 ",
  },
  "gjlb": "国のリスト",
  "qxzgjlb": "国/地域を選択してください",
  "mbwt":{
    "title": "セキュリティの問題",
    "mbwt": "セキュリティの問題",
    "problem":[
      {
        "id": 1,
        "title": "あなたの親友は誰ですか？"
      },
      {
        "id": 2,
        "title": "あなたのアイドルは誰ですか？"
      },
      {
        "id": 3,
        "title": "あなたの最も憧れの場所はどこですか？"
      }
    ],
    "qtxda": "お答えください",
    "qsrxmm": "新しいパスワードを入力してください",
    "qqrmm": "パスワードを確認してください",
    "sydqmmcz": "現行パスワードのリセットを使用する",
    "zhmm": "セキュリティの問題パスワードの取得",
    "ysz": "設定",
    "tg": "省略する",
    "tj": "送信する",
    "zyts": "重要：",
    "zytsCont": "秘密の回答と確認コードを開示しないでください。また、パスワードの取得に役立つセキュリティの問題に注意してください。"
  },
  "zc":{
    "zclb": "アセットリスト",
    "zczh": "資産変換",
    "yczc": "0として非表示のアセット"
  },
  "indexNew":{
    "t1": "グローバルリーディング",
    "t2": "デジタル資産サービスプラットフォーム",
    "t3": "完全なワンストップブロックチェーンデジタル資産トランザクション",
    "t4": "携帯電話番号/メール",
    "t5": "今すぐ登録",
    "t6":"GMO グローバルを通じて世界中からのお客様を歓迎します",
    "t7": "暗号化の旅を発見して開始する"
  },
  "newReg":{
    "dl": ['Eメール','携帯電話'],
    "cjzh": "アカウントを作成する",
    "sysjhzyx": "携帯電話番号/メールで登録",
    "yhxy": "&lt;ーザー契約&gt;",
    "yhxy2": "およびユ&lt;ーザー契約&gt;を読み、同意します ",
    "yxgz": "入力したメールボックスがルールを満たしていない",
    "dhgz": "入力した携帯電話番号の形式が間違っている"
  },
  "indexNew2":{
    "t1": "注文で取引",
    "t2": "ビットバンクを使用",
    "t3": "ビットバンクは、ビットコインと暗号化された資産の巧妙に設計された交換です。非常にシンプル、便利、安全、強力です。複数のWebおよびスマートフォンプラットフォームでのトランザクションをサポートします。トランザクションデータとチャートはリアルタイムで更新されます。包括的な市場価格分析は60以上の技術分析ツールを提供します。取引を開始してください",
    "ksjy": "取引開始",
    "ly": "ビットバンクを選択する5つの理由",
    "item1_t1": "取引量のトップ",
    "item1_t2": "No.1 * Crypto Asset Trading Volume",
    "item1_t3": "流動性が高く、快適な（快適な取引経験）取引。12種類の暗号資産を一覧表示します。",
    "item2_t1": "サードパーティによる高い評価",
    "item2_t2": "安全な取引環境",
    "item2_t3": "オフラインのコールドウォレットを使用します。Multisigを使用してハッカーを締め出します。高度なテクノロジーで資産を保護します",
    "item3_t1": "使いやすく信頼性の高いアプリケーション",
    "item3_t2": "使いやすくシンプルなアプリケーション",
    "item3_t3": "豊富な機能を備えた信頼性の高いアプリケーション。トランザクション以外の取引機会を維持できます。",
    "item4_t1": "終日営業",
    "item4_t2": "金を預けることができます",
    "item4_t3": "休日を含む24時間のデポジットサポート！",
    "item5_t1": "スマートフォンとPC",
    "item5_t2": "人間化されたデザイン",
    "item5_t3": "スマートフォンを使用していても、迷わずシンプルで質の高い取引ができます",
    "aqkk": "安全で信頼できる",
    "aqkk2": "ビットバンクビットコイントランザクション",
    "cjzh": "アカウントを作成",
  },
  "xbsg":{
    "title": "コイン購入",
    "wdsg": "詳細",
    "scts": "ロックアップ日：",
    "sy": "残り",
    "ljsg": "今すぐ購読",
    "ysk": "完売",
    "xzjdy": "今すぐ購読",
    "dy": "購読",
    "fxjg": "発行価格",
    "fxl": "サーキュレーション",
    "ssrq": "上場日",
    "yxqx": "有効期間",
    "qsrsl": "数量を入力してください",
    "syl": "残り",
    "sgrq": "購入日",
    "sgsl": "額",
    "bz": "コイン",
    "yebz": "不十分なUSDTバランス",
    "tgsl": "パス数量",
    "shz": "レビュー中",
    "wtg": "合格しなかった",
    "ytg": "合格しました"
  },
  "wydb":{
    "title": "借りる",
    "db": "借りる",
    "dbz": "借りる",
    "jl": "記録",
    "jdzq": "期間（日）",
    "qhk": "返済",
    "ljdb": "累積（usdt）",
    "dhkbs" :"支払い待ち",
    "jkje": "融資額（usdt）",
    "qsrje": "数量を入力してください",
    "rll": "毎日の金利",
    "hkfs": "返済",
    "dqych": "期限切れ",
    "lx": "興味",
    "fkjg": "貸し手",
    "tpsc": "クレジットローン(画像アップロード)",
    "fwxx": "住宅情報",
    "srzm": "収入の証明（雇用関係）",
    "yhmx": "銀行取引明細書",
    "zjz": "身分証明書の写真",
    "yd": "私は読んで同意しました",
    "xy": "ローン契約を申請する",
    "sqdb": "ローンチェーンに申し込む",
    "gb": "閉鎖",
    "qd": "わかった",
    "ts": "ローン契約の申し込みを確認してください",
    "dbjl": "記録",
    "hkhth": "注文コード",
    "wsh": "未レビュー",
    "yfk": "ローン",
    "sqrq": "適用時間",
    "zq": "サイクル",
    "dbsl": "リブの数",
    "zhke": "支払い合計額",
    "yhkxq": "返済の詳細",
    "bqyhk": "当期の返済額(USDT)",
    "hktips": "残高が十分であることを確認してください。残高が不足している場合は、最初に再充電してから返済してください",
    "bj": "主要",
    "jie": "借りる",
    "ljhk": "すぐに返済",
    "qcz": "預け入れる",
    "yebzqxcz": "残高が不足している場合は、最初に再充電してから返済してください",
    "znj": "延滞料",
    "yqts": "延滞日数"
  },
  "hkxq":{
    "dd":"注文",
    "fzhkdz":"返済先住所をコピーする",
    "hkxq": "返済の詳細",
    "zlx": "総利息",
    "zhk": "総返済",
    "hkjg": "返済機関",
    "qschkpz": "返済証明書をアップロードしてください",
    "hkpz": "返済証明書"
  },
  "bbjyNew":{
    "jylx": "の種類",
    "jyze": "額"
  },
  "bind":{
    "title": "電子メール認証",
    "ybd": "バウンド",
    "wbd": "アンバウンド",
    "ts": "アカウントを保護するために、メールアドレスをバインドすることをお勧めします",
    "qsryxdz": "電子メールアドレス"
  },
  "tipsNew": {
    "yjj": "拒否されました",
    "shz": "償還"
  },
  "newIndex2": {
    "zxhy": "最新の引用",
    "jypt": "取引プラットフォーム",
    "dqwz": "現在の位置",
    "yzm": "確認コード",
    "qrmm": "パスワードの確認",
    "djdl": "クリックしてログイン",
    "ghdjy": "より良い取引",
    "ghdsh": "より良い生活",
    "about": "世界で最も革新的な暗号交換センターがここにあり、数百の暗号通貨を指先で購入、取引、獲得できます。",
    "index01": "ビットコイン以降へのゲートウェイ",
    "index02":"世界をリードするデジタルアセットサービスプラットフォーム",
    "index03": "すべての取引は無料です",
    "index04": "口座開設手数料、口座維持手数料、ストップロス手数料、預金手数料、保管/配送手数料はすべて無料です。",
    "index05": "安全で安全なセキュリティ",
    "index06": "GMI INTは創業以来蓄積された専門知識を活用して、堅牢なシステムを構築し、クライアントの資産を安全かつ確実に保護するためのさまざまなセキュリティ対策を実施しています。",
    "index07": "物理的な取引とレバレッジ取引の両方が利用可能です",
    "index08": "小規模な取引は約10ドルから行うことができ、スプレッドは業界で最も狭く、口座残高はレバレッジ取引の担保として使用できます。レバレッジ手数料を請求できるのはGMI INTのみです。",
    "index09": "GMI INTコミュニティに力を与えるように設計されたトークン",
    "index10": "Unus Sed LEOは、GMI INT取引プラットフォームのメリットと機能を最大化しようとするユーザーがニーズを満たすのに役立つように設計されたアプリケーショントークンです。",
    "index11": "GMI INTコミュニティに力を与えるように設計されたトークン",
    "index12": "より良い生活への道を開く",
    "index13": "誰もが暗号を所有できます。誰もが暗号ソフトウェアを取引できます。これが、Bitgetがあなたをさらに一歩進める方法です。",
    "index14": "革新的な製品",
    "index15": "ワンクリックコピートレード",
    "index16": "取引時にトークンを変換しないでください",
    "index17": "USDC証拠金をサポートする主要なデリバティブ取引所",
    "index18": "ホットウォレットとコールドウォレットの分離によるリスク管理",
    "index19": "SSLLabsからの12a+評価",
    "index20": "Suntwin Technology、Green Pine Cloud Security、HEAP、Armorsがサポートする信頼できるセキュリティ",
    "index21": "優れたカスタマーサービス",
    "index22": "複数の言語での24時間年中無休のオンラインサポート",
    "index23": "VIP顧客向けの1対1のサポート",
    "index24": "コミュニティリワードセンター",
    "index25": "トレーダーがトレーダーのために作成",
    "index26": "ビットコイン、イーサリアム、ソラナ、ドッグコインなどのさまざまなデジタル資産を低い取引コストで取引する",
    "index27": "暗号通貨を購入、販売、取引、投資、使用するために必要なツールと情報",
    "index28": "業界をリードするセキュリティ",
  },
  "langNew":{
    "szhb": "暗号通貨",
    "gjs": "金属",
    "yy": "原油",
    "jy": "トレード",
    "jmhb": "暗号通貨",
    "yxhy": "無期限契約",
    "gdjy": "未決注文",
    "khh": "口座銀行",
    "qsrkhh": "口座銀行を入力してください",
    "yhkh": "銀行カード番号",
    "qsryhkh": "銀行カード番号を入力してください",
    "mnzh":"デモ口座",
    "cjmnzhcg":"デモアカウントが正常に作成されました",
    "tcmnzh":"デモ口座を終了する",
   }
}



// WEBPACK FOOTER //
// ./src/lang/jp.js